import { createSlice } from "@reduxjs/toolkit"
import { fetchCommunicationServices } from "./communication-services-thunk"
import { CommunicationServicesState } from "./types"

export const communicationServicesInitialState: CommunicationServicesState = {
    status: "idle",
    data: null,
    error: null,
}

const communicationServicesSlice = createSlice({
    name: "communicationServices",
    initialState: communicationServicesInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCommunicationServices.pending, (state) => {
                state.status = "loading"
                state.error = null
            })
            .addCase(fetchCommunicationServices.fulfilled, (state, action) => {
                state.status = "succeeded"
                state.data = action.payload
                state.error = null
            })
            .addCase(fetchCommunicationServices.rejected, (state, action) => {
                state.status = "failed"
                state.error = action.payload ?? {
                    kind: "transport",
                    status: null,
                    errorId: null,
                    message: "Не удалось загрузить статистику",
                }
            })
    },
})

export const communicationServicesReducer = communicationServicesSlice.reducer
